export default __webpack_public_path__ + "static/media/buyer.2cfbe6a1.svg";